export default __webpack_public_path__ + "static/media/forum-icon.a73bdd9a.png";